import { useState, useEffect } from 'react';

import CookiesModal from './CookiesModal';

import { Button, Container } from 'react-bootstrap';

const CookieConsent = () => {
    const [showConsent, setShowConsent] = useState(false);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem('cookie-consent');
        if (!consent) {
            setShowConsent(true);
        }
    }, []);

    const acceptCookies = () => {
        localStorage.setItem('cookie-consent', 'true');
        setShowConsent(false);
    };

    if (!showConsent) return null;

    return (
        <>
            <CookiesModal show={showModal} onHide={() => setShowModal(false)} />

            <div className="cookie-banner shadow-lg">
                <Container className="d-flex flex-column flex-md-row align-items-center justify-content-between py-3">
                    <div className="cookie-text mb-3 mb-md-0">
                        <p className="mb-0 small">
                            Utilizamos cookies propias y de terceros para mejorar tu experiencia de navegación
                            y ofrecerte contenido personalizado. Al continuar navegando, aceptas nuestra
                            <span onClick={() => setShowModal(true)} className="ms-1 text-decoration-underline text-dark fw-bold">Política de Cookies</span>.
                        </p>
                    </div>
                    <div className="cookie-actions">
                        <Button
                            onClick={acceptCookies}
                            className="btn-custom-blue rounded-0 border-0 px-4 py-2 text-uppercase fw-bold"
                            style={{ fontSize: '12px', letterSpacing: '1px' }}
                        >
                            Aceptar
                        </Button>
                    </div>
                </Container>
            </div>
        </>
    );
};

export default CookieConsent;